/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationSignpostRightIcon16Light = forwardRef('LocationSignpostRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .5a.5.5 0 0 0-1 0V2H2.5A1.5 1.5 0 0 0 1 3.5v4A1.5 1.5 0 0 0 2.5 9H7v5.5a.5.5 0 0 0 1 0V9h3.81a1.5 1.5 0 0 0 1.106-.486l2.298-2.507a.75.75 0 0 0 0-1.014l-2.298-2.507A1.5 1.5 0 0 0 11.81 2H8V.5ZM11.81 8H2.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h9.31a.5.5 0 0 1 .369.162L14.322 5.5l-2.143 2.338A.5.5 0 0 1 11.81 8Z" })));
});
